/** 手工落收件（#5010）：把表单与上传文件整理成 `POST /signals/inbox/ingest` 的请求体。
 *
 * 文件内容在前端只做「是不是 JSON 对象或数组」这一步解析；内容是否合规（日期对不对、signals 形状）由服务端判，前端不猜。
 */

export interface IngestDraft {
  strategy_id: string;
  trade_date: string;
  /** 上传文件的原文；还没选文件为 null。 */
  fileText: string | null;
  overwrite: boolean;
  operator: string;
  reason: string;
}

export type IngestBody =
  | { ok: true; body: { strategy_id: string; trade_date: string; bridge: unknown; overwrite: boolean; operator: string; reason: string } }
  | { ok: false; error: string };

export function ingestBody(draft: IngestDraft): IngestBody {
  const missing = [
    !draft.strategy_id.trim() && "策略",
    !draft.trade_date && "交易日",
    draft.fileText === null && "桥接文件",
    !draft.operator.trim() && "operator",
    !draft.reason.trim() && "reason",
  ].filter(Boolean);
  if (missing.length) return { ok: false, error: `请填写：${missing.join("、")}` };
  let bridge: unknown;
  try {
    bridge = JSON.parse(draft.fileText as string);
  } catch {
    return { ok: false, error: "桥接文件不是合法 JSON" };
  }
  if (typeof bridge !== "object" || bridge === null) return { ok: false, error: "桥接文件顶层必须是 JSON 对象（BridgeReport）或信号数组" };
  return {
    ok: true,
    body: {
      strategy_id: draft.strategy_id.trim(),
      trade_date: draft.trade_date,
      bridge,
      overwrite: draft.overwrite,
      operator: draft.operator.trim(),
      reason: draft.reason.trim(),
    },
  };
}

/** 「最近收件动作」结论列：手工落收件单独一种；桥接结论沿用链路口径的文案。 */
export function inboxEventLabel(kind: "bridge" | "inbox_ingest", outcome: string | null): { tone: "ok" | "warn" | "neutral" | "missing"; text: string } {
  if (kind === "inbox_ingest") return { tone: "ok", text: "手工落收件" };
  switch (outcome) {
    case null:
      return { tone: "missing", text: "缺" };
    case "bridged":
      return { tone: "ok", text: "已桥接" };
    case "upstream_no_data":
      return { tone: "warn", text: "上游无数据（已补 0 条产物）" };
    case "no_signal":
      return { tone: "neutral", text: "上游当天无信号" };
    default:
      return { tone: "neutral", text: outcome };
  }
}
